'use strict';

import Vue from 'vue';

// App Date Picker
// import AppDatePicker from '@/components/Tools/AppDatePicker';
// Vue.component(AppDatePicker.name, AppDatePicker);

import VueObserveVisibility from 'vue-observe-visibility';
Vue.use(VueObserveVisibility);

export default Vue;
